import "./SinglePostTemplate.module.css"
import MainMenu from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <MainMenu />
      <SinglePostTemplateSection />
      <Footer />
    </div>
  )
}
